import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';
import { getToken, getPatToken } from '../store/utils/storeHelpers.js';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomePro',
    component: () => import('../views/HomePro.vue'),
    meta: {
      requiresAuth: true,
      role: ['pro', 'pat'],
    },
  },
  {
    path: '/profesional',
    name: 'professional',
    component: () => import('../components/father/VFatherProfessional.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro'
    },
    children: [
      {
        path: 'iniciar-sesion',
        name: 'login',
        component: () => import('../views/professional/enter/ProLoginPage.vue'),
        meta: {
          requiresAuth: false,
          role: 'pro'
        },
      },
      {
        path: 'registrarse',
        name: 'signUp',
        component: () => import('../views/professional/enter/ProSignUpPage.vue'),
        meta: {
          requiresAuth: false,
          role: 'pro'
        },
      },
      {
        path: 'legal',
        name: 'homeProLegal',
        component: () => import('../views/HomeProLegal.vue'),
        meta: {
          requiresAuth: false,
          role: 'pro'
        },
      },
    ],
  },
  {
    path: '/pro-verificacion',
    name: 'pro-verification',
    component: () => import('../views/professional/enter/ProOTPPage.vue'),
    meta: {
      requiresAuth: false,
      role: 'pro'
    },
  },
  {
    path: '/cuenta-activada',
    name: 'account-activate',
    component: () => import('../views/HomeActivate.vue'),
    meta: {
      requiresAuth: false,
      role: ['pro', 'pat'],
    },
  },
  {
    path: '/confirmacion',
    name: 'confirmation',
    component: () => import('../views/HomeConfirmation.vue'),
    meta: {
      requiresAuth: false,
      role: ['pro', 'pat'],
    },
  },
  {
    path: '/pro-repass',
    name: 'pro-repass',
    component: () => import('../views/professional/enter/ProRePassPage.vue'),
    meta: {
      requiresAuth: false,
      role: 'pro'
    },
  },
  {
    path: '/pro-home',
    name: 'pro-home',
    component: () => import('../views/professional/ProHomePage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro'
    },
  },
  {
    path: '/legal',
    name: 'proLegal',
    component: () => import('../views/professional/ProLegalPage.vue'),
    meta: {
      requiresAuth: false,
      role: 'pro'
    },
  },
  {
    path: '/mi-cuenta',
    name: 'my-account',
    component: () => import('../views/professional/ProAccountPage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro'
    },
  },
  {
    path: '/perfil',
    name: 'profile',
    component: () => import('../components/father/VFatherProProfile.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro'
    },
    children: [
      {
        path: 'usuario',
        name: 'profile-a',
        component: () => import('../views/professional/ProProfileAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro'
        },
      },
      {
        path: 'estudios',
        name: 'profile-b',
        component: () => import('../views/professional/ProProfileBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro'
        },
      },
      {
        path: 'especialidad',
        name: 'profile-c',
        component: () => import('../views/professional/ProProfileCPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro'
        },
      },
    ],
  },
  {
    path: '/pacientes',
    name: 'patients',
    component: () => import('../components/father/VFatherProPatients.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro',
    },
    children: [
      {
        path: 'agregar',
        name: 'patients-a',
        component: () => import('../views/professional/ProPatientsAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'buscar',
        name: 'patients-b',
        component: () => import('../views/professional/ProPatientsBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'perfil',
        name: 'patients-c',
        component: () => import('../views/professional/ProPatientsCPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'perfil/hcp',
        name: 'hcp',
        component: () => import('../components/father/VFatherProPatientsCHCP.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
        children: [
          {
            path: 'anamnesis',
            name: 'anamnesis',
            component: () => import('../components/father/VFatherProAnamnesis.vue'),
            meta: {
              requiresAuth: true,
              role: 'pro',
            },
            children: [
              {
                path: 'index',
                name: 'index',
                component: () => import('../views/professional/ProPatientsCAnamnesisPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'filiacion',
                name: 'filiation',
                component: () => import('../views/professional/anamnesis/FiliationPersonalPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'motivos-consulta',
                name: 'reason',
                component: () => import('../views/professional/anamnesis/ReasonConsultationPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'condicion-actual',
                name: 'actual-condition',
                component: () => import('../components/father/VFatherProAnamCA.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
                children: [
                  {
                    path: 'entrevista',
                    name: 'interview',
                    component: () => import('../views/professional/anamnesis/CAxInterviewPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'aspecto-fisico',
                    name: 'physical-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxAFSM.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'condicion-fisica',
                        name: 'physical-condition',
                        component: () => import('../views/professional/anamnesis/CAxAFSMxPhysicalCondPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'disfunciones',
                        name: 'dysfunctions',
                        component: () => import('../views/professional/anamnesis/CAxAFSMxDysfunctionPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'psicomotricidad',
                        name: 'psychomotor',
                        component: () => import('../views/professional/anamnesis/CAxAFSMxPsychomotorPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesAFSM',
                        name: 'CAxAFSMxClarifications',
                        component: () => import('../views/professional/anamnesis/CAxAFSMxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-fisiologico',
                    name: 'physiological-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxAFF.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'habitos-basicos',
                        name: 'basic-habits',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFFxBasicHabitsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'sintomas-fisiologicos',
                        name: 'symptoms-pshysiol',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFFxPhysiolSymptomsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'sintomas-musculares',
                        name: 'symptoms-muscular',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFFxMuscularSymptomsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesAFF',
                        name: 'CAxAFFxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFFxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-cognitivo',
                    name: 'cognitive-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxACG.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'atencion',
                        name: 'attention',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxAttentionPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'percepcion',
                        name: 'perception',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxPerceptionPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'memoria',
                        name: 'memory',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxMemoryPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'pensamientoPt1',
                        name: 'thoughtPt1',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxThoughtPt1Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'pensamientoPt2',
                        name: 'thoughtPt2',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxThoughtPt2Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'pensamientoPt3',
                        name: 'thoughtPt3',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxThoughtPt3Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'lenguaje',
                        name: 'language',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxLanguagePage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesACG',
                        name: 'CAxACGxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACGxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-personalidad',
                    name: 'personality-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxARP.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'personalidad',
                        name: 'personality',
                        component: () =>
                          import('../views/professional/anamnesis/CAxARPxPersonalityPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesARP',
                        name: 'CAxARPxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxARPxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-afectivo',
                    name: 'affectivity-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxAAM.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'afectividad',
                        name: 'affectivity',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAAMxAffectivityPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesAAM',
                        name: 'CAxAAMxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAAMxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-comportamental',
                    name: 'behavioral-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxACO.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'comportamientos',
                        name: 'behavioral',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACOxBehavioralPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesACO',
                        name: 'CAxACOxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxACOxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-familiar',
                    name: 'familiar-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxAFA.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'familiares',
                        name: 'family',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFAxFamiliarPt1Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'relacionesFam',
                        name: 'relationshipFam',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFAxFamiliarPt2Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'violenciaFam',
                        name: 'violenceFam',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFAxFamiliarPt3Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesAFA',
                        name: 'CAxAFAxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAFAxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-social',
                    name: 'social-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxASC.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'habilidadesSoc',
                        name: 'socialSkills',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt1Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'interesesSoc',
                        name: 'interestsSoc',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt2Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'sustancias',
                        name: 'substances',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt3Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'pareja',
                        name: 'couple',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt4Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'perdidas',
                        name: 'losses',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt5Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'violenciaSoc',
                        name: 'violenceSoc',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxSocialPt6Page.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesASC',
                        name: 'CAxASCxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASCxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-sexual',
                    name: 'sexual-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxASX.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'sexualidad',
                        name: 'sexual',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASXxSexualPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesASX',
                        name: 'CAxASXxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxASXxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'aspecto-academLab',
                    name: 'academLab-aspect',
                    component: () => import('../components/father/VFatherProAnamCAxASX.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'academico',
                        name: 'academic',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAALxAcademicPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'laboral',
                        name: 'labor',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAALxLaborPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesAAL',
                        name: 'CAxAALxClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxAALxClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'condiciones',
                    name: 'conditions',
                    component: () => import('../components/father/VFatherProAnamCAxCE.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'condiciones-especificas',
                        name: 'specific-conditions',
                        component: () =>
                          import('../views/professional/anamnesis/CAxCExSpecificCondPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'observacionesCE',
                        name: 'CAxCExClarifications',
                        component: () =>
                          import('../views/professional/anamnesis/CAxCExClarificationsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'antecedentes',
                name: 'background',
                component: () => import('../components/father/VFatherProAnamAN.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
                children: [
                  {
                    path: 'desarrollo',
                    name: 'development',
                    component: () => import('../components/father/VFatherProAnamANxAD.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'infancia',
                        name: 'infancy',
                        component: () =>
                          import('../views/professional/anamnesis/ANxADxInfancyPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'ninez',
                        name: 'childhood',
                        component: () =>
                          import('../views/professional/anamnesis/ANxADxChildhoodPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'adolescencia',
                        name: 'adolescence',
                        component: () =>
                          import('../views/professional/anamnesis/ANxADxAdolescencePage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'situaciones-especificas',
                        name: 'specific-situations',
                        component: () =>
                          import('../views/professional/anamnesis/ANxADxSpecificPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'familiar',
                    name: 'familiar',
                    component: () => import('../components/father/VFatherProAnamANxAF.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'miembrosFam',
                        name: 'membersfam',
                        component: () =>
                          import('../views/professional/anamnesis/ANxAFxFamilyMembersPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'academLab',
                    name: 'academLab',
                    component: () => import('../components/father/VFatherProAnamANxAL.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'estudios-basicos',
                        name: 'basic-studies',
                        component: () =>
                          import('../views/professional/anamnesis/ANxALxAcademBasicPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'estudios-superiores',
                        name: 'superior-studies',
                        component: () =>
                          import('../views/professional/anamnesis/ANxALxAcademSuperiorPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'trabajos',
                        name: 'jobs',
                        component: () =>
                          import('../views/professional/anamnesis/ANxALxLaborPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'problemas-salud',
                    name: 'health-problems',
                    component: () => import('../components/father/VFatherProAnamANxAP.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                    children: [
                      {
                        path: 'mental',
                        name: 'mental',
                        component: () =>
                          import('../views/professional/anamnesis/ANxAPxMentalPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'medica',
                        name: 'medical',
                        component: () =>
                          import('../views/professional/anamnesis/ANxAPxMedicalPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                      {
                        path: 'sustancias',
                        name: 'drugs',
                        component: () =>
                          import('../views/professional/anamnesis/ANxAPxDrugsPage.vue'),
                        meta: {
                          requiresAuth: true,
                          role: 'pro',
                        },
                      },
                    ],
                  },
                  {
                    path: 'violencia',
                    name: 'violence',
                    component: () =>
                      import('../views/professional/anamnesis/ANxAVxViolencePage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'delictivos',
                    name: 'criminal',
                    component: () =>
                      import('../views/professional/anamnesis/ANxACxCriminalPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'medicamentos',
                    name: 'medications',
                    component: () =>
                      import('../views/professional/anamnesis/ANxMExMedicationsPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'eventos-relevantes',
                    name: 'relevant-events',
                    component: () =>
                      import('../views/professional/anamnesis/ANxERxRelevantEventsPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'observacionesAN',
                    name: 'ANxClarifications',
                    component: () =>
                      import('../views/professional/anamnesis/ANxClarificationsPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                ],
              },
              {
                path: 'detalles-sintomas',
                name: 'details-symptoms',
                component: () => import('../views/professional/anamnesis/DSxDetailsSymptomsPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'diagnostico-tratamiento',
                name: 'diagTreatment',
                component: () => import('../views/professional/anamnesis/DTxDiagTreatmentPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'observaciones-generales',
                name: 'generalObservation',
                component: () =>
                  import('../views/professional/anamnesis/OGxGeneralObservationPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
            ],
          },
          {
            path: 'pruebas',
            name: 'tests',
            component: () => import('../components/father/VFatherProTests.vue'),
            meta: {
              requiresAuth: true,
              role: 'pro',
            },
            children: [
              {
                path: 'aplicadas',
                name: 'test-applied',
                component: () => import('../views/professional/ProPatientsCTestsPage.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
              },
              {
                path: 'correctores',
                name: 'correctors',
                component: () => import('../components/father/VFatherProTestsCo.vue'),
                meta: {
                  requiresAuth: true,
                  role: 'pro',
                },
                children: [
                  {
                    path: 'lista',
                    name: 'list',
                    component: () => import('../views/professional/tests/CorrectorsPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '01',
                    name: 'co-01',
                    component: () => import('../views/professional/tests/Co01Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '02',
                    name: 'co-02',
                    component: () => import('../views/professional/tests/Co02Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '03',
                    name: 'co-03',
                    component: () => import('../views/professional/tests/Co03Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '04',
                    name: 'co-04',
                    component: () => import('../views/professional/tests/Co04Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '05',
                    name: 'co-05',
                    component: () => import('../views/professional/tests/Co05Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '15',
                    name: 'co-15',
                    component: () => import('../views/professional/tests/Co15Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '16',
                    name: 'co-16',
                    component: () => import('../views/professional/tests/Co16Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '17',
                    name: 'co-17',
                    component: () => import('../views/professional/tests/Co17Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '18',
                    name: 'co-18',
                    component: () => import('../views/professional/tests/Co18Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '20',
                    name: 'co-20',
                    component: () => import('../views/professional/tests/Co20Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '35',
                    name: 'co-35',
                    component: () => import('../views/professional/tests/Co35Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '39',
                    name: 'co-39',
                    component: () => import('../views/professional/tests/Co39Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '41',
                    name: 'co-41',
                    component: () => import('../views/professional/tests/Co41Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '43',
                    name: 'co-43',
                    component: () => import('../views/professional/tests/Co43Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '44',
                    name: 'co-44',
                    component: () => import('../views/professional/tests/Co44Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '45',
                    name: 'co-45',
                    component: () => import('../views/professional/tests/Co45Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '46',
                    name: 'co-46',
                    component: () => import('../views/professional/tests/Co46Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '51',
                    name: 'co-51',
                    component: () => import('../views/professional/tests/Co51Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '52',
                    name: 'co-52',
                    component: () => import('../views/professional/tests/Co52Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: '55',
                    name: 'co-55',
                    component: () => import('../views/professional/tests/Co55Page.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                  {
                    path: 'resultados',
                    name: 'test-result',
                    component: () => import('../views/professional/tests/CoResultsPage.vue'),
                    meta: {
                      requiresAuth: true,
                      role: 'pro',
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'informe',
            name: 'report',
            component: () => import('../views/professional/ProPatientsCReportPage.vue'),
            meta: {
              requiresAuth: true,
              role: 'pro',
            },
          },
          {
            path: 'terapia',
            name: 'therapy',
            component: () => import('../views/professional/ProPatientsCTherapyPage.vue'),
            meta: {
              requiresAuth: true,
              role: 'pro',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/citas',
    name: 'appointments',
    component: () => import('../components/father/VFatherProAppointments.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro',
    },
    children: [
      {
        path: 'programadas',
        name: 'appointments-a',
        component: () => import('../views/professional/ProAppointmentsAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'solicitadas',
        name: 'appointments-b',
        component: () => import('../views/professional/ProAppointmentsBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
    ],
  },
  {
    path: '/estadisticas',
    name: 'statistics',
    component: () => import('../components/father/VFatherProStatistics.vue'),
    meta: {
      requiresAuth: true,
      role: 'pro',
    },
    children: [
      {
        path: 'pacientes-ingresados',
        name: 'statistics-a',
        component: () => import('../views/professional/ProStatisticsAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'pruebas-aplicadas',
        name: 'statistics-b',
        component: () => import('../views/professional/ProStatisticsBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
      {
        path: 'data-integrada',
        name: 'statistics-c',
        component: () => import('../views/professional/ProStatisticsCPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pro',
        },
      },
    ],
  },
  {
    path: '/paciente',
    name: 'patient',
    component: () => import('../components/father/VFatherPatient.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
    children: [
      {
        path: 'info',
        name: 'HomePat',
        component: () => import('../views/HomePac.vue'),
        meta: {
          requiresAuth: false,
          role: 'pat'
        },
      },
      {
        path: 'iniciar-sesion',
        name: 'patLogin',
        component: () => import('../views/patient/enter/PatLoginPage.vue'),
        meta: {
          requiresAuth: false,
          role: 'pat'
        },
      },
      {
        path: 'registrarse',
        name: 'patSignUp',
        component: () => import('../views/patient/enter/PatSignUpPage.vue'),
        meta: {
          requiresAuth: false,
          role: 'pat'
        },
      },
      {
        path: 'legal',
        name: 'homePatLegal',
        component: () => import('../views/HomePatLegal.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
    ],
  },
  {
    path: '/pat-verificacion',
    name: 'pat-verification',
    component: () => import('../views/patient/enter/PatOTPPage.vue'),
    meta: {
      requiresAuth: false,
      role: 'pat'
    },
  },
  {
    path: '/pat-repass',
    name: 'pat-repass',
    component: () => import('../views/patient/enter/PatRePassPage.vue'),
    meta: {
      requiresAuth: false,
      role: 'pat'
    },
  },
  {
    path: '/pat-home',
    name: 'pat-home',
    component: () => import('../views/patient/PatHomePage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
  },
  {
    path: '/legales',
    name: 'patLegal',
    component: () => import('../views/patient/PatLegalesPage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
  },
  {
    path: '/mi-cuenta-pat',
    name: 'my-account-pat',
    component: () => import('../views/patient/PatAccountPage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
  },
  {
    path: '/perfil',
    name: 'profilePat',
    component: () => import('../components/father/VFatherPatProfile.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
    children: [
      {
        path: 'paciente',
        name: 'patient-a',
        component: () => import('../views/patient/PatProfileAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
      {
        path: 'encuestas',
        name: 'patient-b',
        component: () => import('../views/patient/PatProfileBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
    ],
  },
  {
    path: '/historias',
    name: 'record',
    component: () => import('../components/father/VFatherPatRecord.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
    children: [
      {
        path: 'transferencias',
        name: 'record-a',
        component: () => import('../views/patient/PatRecordAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
      {
        path: 'derivaciones',
        name: 'record-b',
        component: () => import('../views/patient/PatRecordBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
    ],
  },
  {
    path: '/citas-pat',
    name: 'appointmentsPat',
    component: () => import('../components/father/VFatherPatAppointments.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
    children: [
      {
        path: 'programadas',
        name: 'appointmentsPat-a',
        component: () => import('../views/patient/PatAppointmentsAPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
      {
        path: 'solicitadas',
        name: 'appointmentsPat-b',
        component: () => import('../views/patient/PatAppointmentsBPage.vue'),
        meta: {
          requiresAuth: true,
          role: 'pat'
        },
      },
    ],
  },
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('../views/patient/PatInboxPage.vue'),
    meta: {
      requiresAuth: true,
      role: 'pat'
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes,
});

router.onError((error) => {
  if (error.name === 'ChunkLoadError') {
    const chunkReload = sessionStorage.getItem('chunk-reload');
    if (!chunkReload) {
      sessionStorage.setItem('chunk-reload', '1');
      window.location.reload(true); 
    } else {
      console.error('Evitando bucle infinito de ChunkLoadError');
    }
  }
});

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp && payload.exp < now;
  } catch {
    return true;
  }
}

router.beforeEach((to, from, next) => {
  const publicPages = new Set([
    '/',
    '/profesional/iniciar-sesion',
    '/profesional/registrarse',
    '/profesional/legal',
    '/paciente/info',
    '/paciente/iniciar-sesion',
    '/paciente/registrarse',
    '/paciente/legal',
    '/pro-verificacion',
    '/pat-verificacion',
    '/cuenta-activada',
    '/pro-repass',
    '/pat-repass',
    '/confirmacion',
  ]);

  const token = getToken();
  const patToken = getPatToken();

  const isTokenValid = token && !isTokenExpired(token);
  const isPatTokenValid = patToken && !isTokenExpired(patToken);

  if (to.path === '/') {
    const lastRoute = localStorage.getItem('lastRoute');
    if (lastRoute && lastRoute !== '/') {
      if ((isTokenValid || isPatTokenValid)) {
        return next(lastRoute);
      }
    }
    if (isTokenValid) return next('/pro-home');
    if (isPatTokenValid) return next('/pat-home');
  }

  const isProLogin = to.path === '/profesional/iniciar-sesion' || to.name === 'login';
  const isPatLogin = to.path === '/paciente/iniciar-sesion' || to.name === 'patLogin';

  if (isProLogin && isTokenValid) return next('/pro-home');
  if (isPatLogin && isPatTokenValid) return next('/pat-home');

  const isPublic = publicPages.has(to.path);
  if (isPublic) return next();

  if (!isTokenValid && !isPatTokenValid) {
    store.commit('RESET_ALL');
    
    localStorage.removeItem('token'); 
    localStorage.removeItem('patToken');
    localStorage.removeItem('lastRoute'); 
    
    return next('/');
  }

  const requiredRole = to.meta.role;
  const rolesAllowed = Array.isArray(requiredRole)
    ? requiredRole
    : requiredRole !== undefined
      ? [requiredRole]
      : ['pro', 'pat'];

  let userRole = null;
  if (rolesAllowed.includes('pat') && isPatTokenValid) userRole = 'pat';
  if (!userRole && rolesAllowed.includes('pro') && isTokenValid) userRole = 'pro';

  if (!userRole) {
    if (rolesAllowed.includes('pro')) return next('/profesional/iniciar-sesion');
    if (rolesAllowed.includes('pat')) return next('/paciente/iniciar-sesion');
    return next('/');
  }

  next();
});

router.afterEach((to) => {
  sessionStorage.removeItem('chunk-reload');

  const publicPaths = [
    '/', 
    '/profesional/iniciar-sesion', 
    '/paciente/iniciar-sesion',
    '/profesional/registrarse',
    '/paciente/registrarse'
  ];
  
  if (!publicPaths.includes(to.path)) {
    localStorage.setItem('lastRoute', to.path);
  }
});

export default router;